var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { styled, LinearProgress, Box, } from '@mui/material';
import filesize from 'filesize';
import { CancelIcon } from '../../icons';
import { Message } from '../../';
function formatInfo(size, percent) {
    return filesize(size * (percent / 100)) + " / " + filesize(size);
}
var ImgWrapper = styled(Box)(function (_a) {
    var _b = _a.width, width = _b === void 0 ? 120 : _b, _c = _a.height, height = _c === void 0 ? 120 : _c;
    return ({
        position: 'relative',
        width: width,
        height: height,
        border: '1px solid transparent',
        borderRadius: '4px',
        '&:hover .fbm-cube-hidden': {
            display: 'flex',
        },
        margin: '0 8px 8px 0',
    });
});
var DeleteBtn = styled(Box)(function () { return ({
    display: 'none',
    position: 'absolute',
    top: -10,
    right: -10,
    backgroundColor: 'white',
    borderRadius: '100%',
    cursor: 'pointer',
    zIndex: 2,
}); });
var EditBtn = styled(Box)(function () { return ({
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 32,
    fontSize: '14px',
    color: 'white',
    backgroundColor: 'rgba(0,0,0,0.56)',
    borderEndStartRadius: '4px',
    borderEndEndRadius: '4px',
    cursor: 'pointer',
}); });
var UploadingRoot = styled(Box)({
    padding: '0 10px',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(0,0,0,0.56)',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    inset: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});
var Progress = styled(LinearProgress)({
    width: '100%',
    borderRadius: 4,
});
var progressColors = {
    uploading: 'primary',
    error: 'error',
    done: 'primary',
};
var ListItem = function (_a) {
    var 
    // 文件名称
    name = _a.name, originFileObj = _a.originFileObj, size = _a.size, 
    // 上传进度
    percentProp = _a.percent, 
    // 上传状态
    status = _a.status, iconType = _a.iconType, onClose = _a.onClose, onRefresh = _a.onRefresh, nameRender = _a.nameRender, restProps = __rest(_a, ["name", "originFileObj", "size", "percent", "status", "iconType", "onClose", "onRefresh", "nameRender"]);
    var blobSrc = useMemo(function () {
        // @ts-ignore
        if (originFileObj === null || originFileObj === void 0 ? void 0 : originFileObj.originFileObj) {
            // @ts-ignore
            return URL.createObjectURL(originFileObj.originFileObj);
        }
        return URL.createObjectURL(originFileObj);
    }, []);
    var progress = status === 'error' ? 100 : percentProp;
    React.useEffect(function () {
        var time = null;
        if (status === 'error') {
            Message.error('图片上传失败，请重试');
            time = setTimeout(function () {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }, 700);
        }
        return function () {
            clearTimeout(time);
        };
    }, [status]);
    return (React.createElement(ImgWrapper, __assign({}, restProps),
        React.createElement("img", { src: blobSrc, width: "100%", height: "100%", style: { borderRadius: '4px', objectFit: 'cover' } }),
        React.createElement(DeleteBtn, { className: "fbm-cube-hidden", onClick: function () { return onClose(); } },
            React.createElement(CancelIcon, { sx: { width: 20, height: 20 } })),
        (status === 'uploading' || status === 'error') && (React.createElement(UploadingRoot, null,
            React.createElement(Progress, { variant: "determinate", value: progress, color: progressColors[status] })))));
};
export default ListItem;
